import i18n from 'i18next';
import LanguageDetector from './language-detector';  //'i18next-browser-languagedetector';
import * as lang from "./_exports";

const en_master = lang.en_master;

const getTranslations  = (language: "en" | "es" | "fr") => {
    const tags = document.getElementsByName("eto:site");
    const siteId = tags.length === 0 ? 12 : (tags[0] as HTMLMetaElement).content;
    const st = (lang as any)[`${language}_${siteId}`] as typeof en_master;
    const nt =  (lang as any)[`${language}_master`] as typeof en_master;
    st && st.basket ? Object.assign(nt.basket, st.basket) : void 0;
    st && st.login ? Object.assign(nt.login, st.login) : void 0;
    st && st.menu ? Object.assign(nt.menu, st.menu) : void 0;
    st && st.home ? Object.assign(nt.home, st.home) : void 0;
    st && st.send_balance ? Object.assign(nt.send_balance, st.send_balance) : void 0;
    st && st.auto_balance ? Object.assign(nt.auto_balance, st.auto_balance) : void 0;
    st && st.receipt ? Object.assign(nt.receipt, st.receipt) : void 0;
    st && st.support ? Object.assign(nt.support, st.support) : void 0;
    st && st.constants ? Object.assign(nt.constants, st.constants) : void 0;
    st && st.common ? Object.assign(nt.common, st.common) : void 0;
    st && st.error ? Object.assign(nt.error, st.error) : void 0;
    st && st.messages ? Object.assign(nt.messages, st.messages) : void 0;
    st && st.social ? Object.assign(nt.social, st.social) : void 0;
    st && st.validations ? Object.assign(nt.validations, st.validations) : void 0;
    st && st.myaccount ? Object.assign(nt.myaccount, st.myaccount) : void 0;
    return nt;
}
i18n
    .use(LanguageDetector)
    .init({
        fallbackLng: 'en',
        debug: true,
        react: {
            wait: false,
        },
        resources: {
            "en": {
                "translation": getTranslations("en")
            },
            "es": {
                "translation": getTranslations("es")
            },
            "fr": {
                "translation": getTranslations("fr")
            }
        }
    });

const t = i18n.t.bind(i18n) as i18n.TranslationFunction<any, object, string>;
const strict = {
    currentLanguage: () => {
        return i18n.language;
    },
    basket: (value: keyof (typeof en_master.basket), options?: i18n.TranslationOptions<object>) => {
        return t(`basket.${value}`, options);
    },
    login: (value: keyof (typeof en_master.login), options?: i18n.TranslationOptions<object>) => {
        return t(`login.${value}`, options);
    },
    menu: (value: keyof (typeof en_master.menu), options?: i18n.TranslationOptions<object>) => {
        return t(`menu.${value}`, options);
    },
    //home
    topup: (value: keyof (typeof en_master.send_balance), options?: i18n.TranslationOptions<object>) => {
        return t(`send_balance.${value}`, options);
    },
    autoTopup: (value: keyof (typeof en_master.auto_balance), options?: i18n.TranslationOptions<object>) => {
        return t(`auto_balance.${value}`, options);
    },
    receipt: (value: keyof (typeof en_master.receipt), options?: i18n.TranslationOptions<object>) => {
        return t(`receipt.${value}`, options);
    },
    //support
    //constants
    common: (value: keyof (typeof en_master.common), options?: i18n.TranslationOptions<object>) => {
        return t(`common.${value}`, options);
    },
    error: (value: keyof (typeof en_master.error), options?: i18n.TranslationOptions<object>) => {
        return t(`error.${value}`, options);
    },
    messages: (value: keyof (typeof en_master.messages), options?: i18n.TranslationOptions<object>) => {
        return t(`messages.${value}`, options);
    },
    social: (value: keyof (typeof en_master.social), options?: i18n.TranslationOptions<object>) => {
        return t(`social.${value}`, options);
    },
    validations: (value: keyof (typeof en_master.validations), options?: i18n.TranslationOptions<object>) => {
        return t(`validations.${value}`, options);
    },
    myaccount: (value: keyof (typeof en_master.myaccount), options?: i18n.TranslationOptions<object>) => {
        return t(`myaccount.${value}`, options);
    },
}
export default strict;